var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React from 'react';

import { actions } from "../BasicReducer";
import { unselectAllDocuments } from "../Library/actions/libraryActions";
import { wrapDispatch } from "../Multireducer";
import RouteHandler from "../App/RouteHandler";
import ViewMetadataPanel from "../Library/components/ViewMetadataPanel";
import SelectMultiplePanelContainer from "../Library/containers/SelectMultiplePanelContainer";

import { ErrorBoundary } from "../App/ErrorHandling/ErrorBoundary";
import { PageViewer } from "./components/PageViewer";
import { getPageAssets } from "./utils/getPageAssets";

class PageView extends RouteHandler {
  static async requestState(requestParams) {
    try {
      const { pageView, itemLists, datasets } = await getPageAssets(requestParams);
      return [
      actions.set('page/pageView', pageView),
      actions.set('page/itemLists', itemLists),
      actions.set('page/datasets', datasets)];

    } catch (e) {
      return [actions.set('page/error', e)];
    }
  }

  closeSidePanel() {
    wrapDispatch(this.context.store.dispatch, 'library')(unselectAllDocuments());
  }

  componentDidMount() {
    this.closeSidePanel();
  }

  componentWillUnmount() {
    this.emptyState();
  }

  emptyState() {
    this.closeSidePanel();
    this.context.store.dispatch(actions.unset('page/pageView'));
    this.context.store.dispatch(actions.unset('page/itemLists'));
    this.context.store.dispatch(actions.unset('page/datasets'));
    this.context.store.dispatch(actions.unset('page/error'));
  }

  setReduxState(state) {
    this.context.store.dispatch(actions.set('page/pageView', state.page.pageView));
    this.context.store.dispatch(actions.set('page/itemLists', state.page.itemLists));
    this.context.store.dispatch(actions.set('page/datasets', state.page.datasets));
    this.context.store.dispatch(actions.set('page/error', state.page.error));
  }

  render() {
    return /*#__PURE__*/(
      _jsx(ErrorBoundary, {}, void 0, /*#__PURE__*/
      _jsx(PageViewer, {}), /*#__PURE__*/
      _jsx(ViewMetadataPanel, { storeKey: "library" }), /*#__PURE__*/
      _jsx(SelectMultiplePanelContainer, { storeKey: "library" })));


  }
}

export default PageView;